import React from 'react';

import { useStyles } from './styles';

export const Button = ({buttonWrapperClassName, className, onClick, disabled, bottomMargin, typographyVariant, typographyText, children, ...props}: any) => {

    const { buttonWrapper, button, buttonDisabled, marginBottom, buttonText } = useStyles();

    const btnClassName = `${button} ${className} ${disabled && buttonDisabled} ${bottomMargin && marginBottom}`;
    const btnWrapperClassName = `${buttonWrapper} ${buttonWrapperClassName}`;

    const clickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (onClick) {
            onClick(e);
        }
    };

    return (
            <div className={btnWrapperClassName}>
                <button
                    onClick={clickHandler}
                    className={btnClassName}
                    disabled={disabled}
                    {...props}>
                        {children}
                        {typographyText
                            ? (
                                <p className={buttonText}>
                                    {typographyText}
                                </p>
                            )
                            : null
                        }
                </button>
            </div>
        );
}
